import React from "react";
import clsx from "clsx";

export function Card({ className = "", children }) {
    return (
        <div className={clsx("rounded-2xl border border-slate-200 dark:border-slate-800 bg-white/80 dark:bg-slate-800/80 backdrop-blur", className)}>
            {children}
        </div>
    );
}

export function CardHeader({ className = "", children }) {
    return <div className={clsx("px-4 pt-4", className)}>{children}</div>;
}

export function CardTitle({ className = "", children }) {
    return <h3 className={clsx("text-lg font-semibold", className)}>{children}</h3>;
}

export function CardContent({ className = "", children }) {
    return <div className={clsx("px-4 pb-4 text-slate-600 dark:text-slate-300", className)}>{children}</div>;
}
